import { Component, OnInit } from '@angular/core';
import { ReportUser } from 'src/app/models/db/report-user';
import { ReportUserService, AlertService } from 'src/app/services';
import { BlockUIHandlerService } from 'src/app/common/services.index';
import { ALERTS } from 'src/app/common/enums';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-report-users',
  templateUrl: './report-users.component.html',
  styleUrls: ['./report-users.component.css']
})
export class ReportUsersComponent implements OnInit {
  //VARBOX
  isPasswordInputReandOnly: boolean;
  modalReference: NgbModalRef;
  reportUsers: ReportUser[];
  reportUser: ReportUser;
  reportUserForm: FormGroup;
  private originalPassword: string;
  constructor(private reportUserService: ReportUserService
    ,private alertService: AlertService
    ,private blockUiService: BlockUIHandlerService
    ,private formBuilder: FormBuilder
    ,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.InitVariables();
  }

  InitVariables(): void {
    this.isPasswordInputReandOnly = true;
    this.ResetReportUserForm();
    this.LoadData();
  }

  LoadData(): void {
    this.Get();
  }

  Store(): void {
    if (this.reportUserForm.get('Username').invalid || this.reportUserForm.get('Description').invalid) {
      this.reportUserForm.get('Username').markAsTouched();
      this.reportUserForm.get('Description').markAsTouched();
      this.alertService.ShowSmallCornerAlert(`Nombre de usuario y descripción son requeridos`, ALERTS.info);
      return;
    }

    const REPORT_USER = this.reportUserForm.value as ReportUser;
    REPORT_USER.Id === -1 ? this.CreateReportUser(REPORT_USER): this.UpdateReportUser(REPORT_USER);
  }

  RaiseReportUserModal(content, isUpdating: boolean = false): void {
    if (!isUpdating) {
      this.ResetReportUserForm();
      this.isPasswordInputReandOnly = true;
      this.reportUserForm.patchValue({
        UpdatePassword: true
      });
    }
    else {
      this.isPasswordInputReandOnly = false;
      this.reportUserForm.patchValue({
        UpdatePassword: false
      });
    }

    this.modalReference = this.modalService.open(content,
      {
        centered: true,
        backdrop: 'static'
      });
  }

  CloseModal(): void {
    this.modalReference.close();
  }

  ResetReportUserForm(): void {
    this.reportUserForm = this.formBuilder.group({
      Id: [-1],
      Username: ['', Validators.required],
      Description: ['', Validators.required],
      Password: [''],
      Active: [false, Validators.required],
      UpdatePassword: [false]
    });
  }

  Get(): void {
    this.blockUiService.Start(1, `Procesando, espere por favor`);
    this.reportUserService.Get().pipe(finalize(() => this.blockUiService.Stop())).subscribe(next => {
      if (next.Result) {
        this.reportUsers = next.ReportUsers;
        this.alertService.ShowSmallCornerAlert(`Usuarios de reportes obtenidos`, ALERTS.success);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  GetReportUser(_id: number, content: any): void {
    this.blockUiService.Start(1, `Procesando, espere por favor`);
    this.reportUserService.GetById(_id).pipe(finalize(() => this.blockUiService.Stop())).subscribe(next => {
      if (next.Result) {
        this.reportUser = next.Data;
        this.originalPassword = this.reportUser.Password;
        this.reportUser.Password = '';
        this.reportUserForm.patchValue({
          ...this.reportUser
        });
        this.RaiseReportUserModal(content, true);
      }
      else {
        this.alertService.ShowSmallCornerAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.warning);
      }
    }, error => {
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });
  }

  CreateReportUser(_reportUser: ReportUser): void {
    let MOBJECT = { ...this.reportUserForm.value };

    if (!MOBJECT.UpdatePassword) {
      this.alertService.ShowSmallCornerAlert(`El check de editar contraseña debe de estar seleccionado`, ALERTS.info);
      return;
    }
    if (!_reportUser.Password) {
      this.alertService.ShowSmallCornerAlert(`La contraseña es requerida`, ALERTS.info);
      return;
    }
    this.blockUiService.Start(1, `Creando usuario de reporte`);
    this.reportUserService.Store(_reportUser).subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.CloseModal();
        this.alertService.ShowSmallCornerAlert(`Usuario de reporte creado`, ALERTS.success);
        this.Get();
      }
      else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  UpdateReportUser(_reportUser: ReportUser): void {

    let MOBJECT = { ...this.reportUserForm.value };

    if (!MOBJECT.UpdatePassword) {
      // No se envía null: Common.GetValuesToRecord serializa un valor null como
      // cadena vacía en vez de la palabra NULL, lo que rompe la sintaxis del
      // EXEC posicional. Se reenvía la contraseña original sin cambios.
      _reportUser.Password = this.originalPassword;
    }
    else {
      if (!_reportUser.Password) {
        this.alertService.ShowSmallCornerAlert(`La contraseña es requerida`, ALERTS.info);
        return;
      }
    }

    this.blockUiService.Start(1, `Actualizando usuario de reporte`);
    this.reportUserService.Store(_reportUser).subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        this.CloseModal();
        this.alertService.ShowSmallCornerAlert(`Usuario de reporte actualizado`, ALERTS.success);
        this.Get();
      }
      else {
        this.alertService.ShowBigCenteredAlert(`Error: ${next.ErrorInfo.Message}`, ALERTS.error);
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowBigCenteredAlert(`Error: ${error}`, ALERTS.error);
    });
  }

  ToggleInputPasswordType(): void {
    this.isPasswordInputReandOnly = !this.isPasswordInputReandOnly
  }
}
